export default __webpack_public_path__ + "static/media/result-temp.ba1c4357.svg";